module.exports = __webpack_public_path__ + "img/brighton-hove-albion.d20743b0.png";